/*
    This is the container for selecting scenes
*/

import React from 'react'
import { arrayOf, func, number, bool } from 'prop-types'
import { connect } from 'react-redux'

import { openScene } from 'models/scenes/actions'
import { scenesToggle, selectSceneSelectionTab } from 'models/ui/actions'
import { sceneType } from 'models/propTypes'

import { getUserSceneItems, getStockSceneItems, getSelectedSceneId } from 'models/scenes/selectors'
import { getSceneSelectionTabShowStock } from 'models/ui/selectors'

import SceneSelection from 'components/SceneSelection'

const SceneSelectionContainer = ({
    userSceneItems,
    stockSceneItems,
    onSelectScene,
    selectedSceneId,
    close,
    viewUserScenes,
    viewStockScenes,
    showStockTab,
}) => (
    <SceneSelection
        userSceneItems={userSceneItems}
        stockSceneItems={stockSceneItems}
        onSelectScene={onSelectScene}
        selectedSceneId={selectedSceneId}
        close={close}
        viewUserScenes={viewUserScenes}
        viewStockScenes={viewStockScenes}
        showStockTab={showStockTab}
    />
)

SceneSelectionContainer.defaultProps = {
    selectedSceneId: null,
}

SceneSelectionContainer.propTypes = {
    userSceneItems: arrayOf(sceneType).isRequired,
    stockSceneItems: arrayOf(sceneType).isRequired,
    onSelectScene: func.isRequired,
    selectedSceneId: number,
    close: func.isRequired,
    viewUserScenes: func.isRequired,
    viewStockScenes: func.isRequired,
    showStockTab: bool.isRequired,
}

const mapStateToProps = (state) => ({
    userSceneItems: getUserSceneItems(state),
    stockSceneItems: getStockSceneItems(state),
    selectedSceneId: getSelectedSceneId(state),
    showStockTab: getSceneSelectionTabShowStock(state),
})

const mapDispatchToProps = (dispatch) => ({
    onSelectScene: (id) => dispatch(openScene(id)),
    close: () => dispatch(scenesToggle()),
    viewUserScenes: () => dispatch(selectSceneSelectionTab(false)),
    viewStockScenes: () => dispatch(selectSceneSelectionTab(true)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SceneSelectionContainer)
